<template>
  <div class="home-container">
    <transition name="side-right">
      <side-right />
    </transition>
    <private-map />
    <transition name="el-fade-in">
      <car-dialog v-if="car_dialog.visible" />
    </transition>
    <div class="screen" @click="screenClick">
      <i v-if="full_screen" class="iconfont icon-quanping"></i>
      <i v-else class="iconfont icon-suofang"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SideRight, PrivateMap } from './components/index'
import CarDialog from './components/dialog/car'

export default {
  data() {
    return {
      frame_num: '',
      car_dialog: {
        visible: false
      }
    }
  },
  components: { SideRight, PrivateMap, CarDialog },
  computed: {
    ...mapGetters(['full_screen'])
  },
  methods: {
    screenClick() {
      this.$store.dispatch('home/fullScreenToggle')
    },
    openCarDialog(frame_num) {
      this.frame_num = frame_num
      this.car_dialog.visible = true
    },
    closeCarDialog() {
      this.car_dialog.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.screen {
  position: absolute;
  right: 380px;
  top: 14px;
  color: #2f83b0;
  cursor: pointer;
  .iconfont {
    font-size: 32px;
  }
}
</style>
